export default __webpack_public_path__ + "static/media/7SD84.b0176a61.jpg";